import { useRef, useState } from "react";
import { Eye, FileText, Loader2, Upload, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const ACCEPT = "image/jpeg,image/png,image/webp,application/pdf";

export function CnhUpload({ value, courierId, savedPath, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [local, setLocal] = useState("");
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) return toast.error("O arquivo deve ter no máximo 10 MB");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      onChange((await api.post("/couriers/cnh-upload", fd)).data);
      setLocal(URL.createObjectURL(file));
      toast.success("CNH enviada. Clique em Salvar para guardar.");
    } catch (err) {
      toast.error(errMsg(err, "Não foi possível enviar a CNH"));
    } finally {
      setBusy(false);
    }
  };
  const view = async () => {
    if (local) return window.open(local, "_blank");
    try {
      const { data } = await api.get(`/couriers/${courierId}/cnh`, { responseType: "blob" });
      window.open(URL.createObjectURL(data), "_blank");
    } catch (err) {
      toast.error(errMsg(err, "Não foi possível abrir a CNH"));
    }
  };
  const canView = value && (local || (courierId && value.path === savedPath));
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-md border border-dashed p-3" data-testid="courier-cnh-upload">
      <FileText className="h-5 w-5 shrink-0 text-muted-foreground" />
      <span className="min-w-0 flex-1 truncate text-sm text-muted-foreground" data-testid="courier-cnh-name">{value ? value.filename || "CNH enviada" : "Foto da CNH ou CNH digital (imagem ou PDF, até 10 MB)"}</span>
      {canView && <Button type="button" size="sm" variant="ghost" onClick={view} data-testid="courier-cnh-view"><Eye className="mr-1 h-4 w-4" />Ver</Button>}
      {value && <Button type="button" size="sm" variant="ghost" onClick={() => { onChange(null); setLocal(""); }} data-testid="courier-cnh-remove"><X className="mr-1 h-4 w-4" />Remover</Button>}
      <Button type="button" size="sm" variant="outline" disabled={busy} onClick={() => ref.current?.click()} data-testid="courier-cnh-btn">
        {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Upload className="mr-1 h-4 w-4" />}{value ? "Trocar" : "Enviar"}
      </Button>
      <input ref={ref} type="file" accept={ACCEPT} className="hidden" onChange={pick} data-testid="courier-cnh-input" />
    </div>
  );
}
